import RankingFutbolero from "./RankingFutbolero";

export default function RankingFutbolero1() {
  return (
    <RankingFutbolero
      titulo="Rank Futbolero Dinámica 1"
      descripcion="13 de junio – 31 de julio"
      notaPremio="Top 40 · Premio $400"
      tipoCampana="futbolero1"
      mesesCierre={7}
      columnaValorLabel="Puntos"
      mostrarMonto
    />
  );
}
